'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _pickup_station = require('../actions/pickup_station');

var _pickup_station_form = require('../components/pickup_station_form');

var _pickup_station_form2 = _interopRequireDefault(_pickup_station_form);

var _pickup_station_list = require('../components/pickup_station_list');

var _pickup_station_list2 = _interopRequireDefault(_pickup_station_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupStation = _react2.default.createClass({
    displayName: 'PickupStation',

    propTypes: {
        pickupStations: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _pickup_station.fetchPickupStationsIfNeeded)(filter));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'pickup-stations', className: 'clearfix' },
            _react2.default.createElement(_pickup_station_form2.default, { style: { marginBottom: 20 } }),
            _react2.default.createElement(_pickup_station_list2.default, { pickupStations: this.props.pickupStations })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var pickupStations = store.pickupStation.pickupStations;

    return {
        pickupStations: pickupStations
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PickupStation);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/pickup_stations.js
// module id = 1549
// module chunks = 0